import styled from 'styled-components';
import { theme } from '../theme';

export interface TypographyProps {
  fontWeight?: React.CSSProperties['fontWeight'];
  align?: React.CSSProperties['textAlign'];
  color?: React.CSSProperties['color'];
  textTransform?: React.CSSProperties['textTransform'];
}

export const DisplayTitle = styled.h1`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h1-font-size);
  line-height: var(--h1-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const HeadlineTitle = styled.h2`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h2-font-size);
  line-height: var(--h2-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const ParagraphTitle = styled.h3`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h3-font-size);
  line-height: var(--h3-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
  text-transform: uppercase;
`;

export const Subtitle = styled.h4`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h4-font-size);
  line-height: var(--h4-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const BodyText = styled.p`
  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
  white-space: pre-line;
`;

export const Label = styled.h5`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h5-font-size);
  line-height: var(--h5-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
  text-transform: uppercase;
`;

export const Disclaimer = styled.h6`
  font-family: ${theme.fonts.arial};
  font-weight: ${theme.fontWeight.thin};
  font-size: ${theme.fontSizes.h6};
  line-height: var(--h6-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const Span = styled.span<TypographyProps>`
  ${({ color }) => `color: ${color};`};
  ${({ fontWeight }) => `font-weight: ${fontWeight};`};
  ${({ textTransform }) => `text-transform: ${textTransform};`};
`;
